module.exports = __webpack_public_path__ + "static/media/xueshan6.76de67e1.jpg";